import { Avatar, AvatarProps } from '@doveit/bricks';
import React from 'react';
import { Aggregator } from '../../../domain/types';
import { aggregatorIcons } from '../../constants';

export interface PublishedOnAvatarProps extends Pick<AvatarProps, 'size' | 'placeholder'> {
  aggregator: Aggregator,
}

export const PublishedOnAvatar: React.FC<PublishedOnAvatarProps> = ({
  aggregator,
  size,
}) => (
  <Avatar
    placeholder={aggregatorIcons[aggregator]}
    size={size}
  />
);

export default PublishedOnAvatar;
